import React, { forwardRef, useState, useEffect } from 'react'

import { localeDecimal, addDecimal, convert } from 'src/utils/NumberSystem'

const MoneyField = ({ exponent = 2, decimal, onChange, value, ...props }, ref) => {
  const filter = value =>
    convert(value)
    .match(exponent ? new RegExp(`^(\\d*(\\.\\d{0,${exponent}})?)`) : /^(\d*)/)[0]
    .replace(/^0*(0$|0\.|[1-9])/, '$1') // remove leading zeroes

  const handleChange = e => {
    const filteredValue = filter(e.target.value)
    setInternalValue(filteredValue)
    if (onChange && !Number.isNaN(Number(filteredValue)))
      onChange({ ...e, target: { ...e.target, value: filteredValue } })
  }

  const [ internalValue, setInternalValue ] = useState(filter(String(value)))

  useEffect(() => {
    if (Number(internalValue) != Number(value))
      setInternalValue(filter(String(value)))
  }, [ value ])

  useEffect(() => { decimal && addDecimal(decimal) }, [ decimal ])

  return (
    <input {...props}
      ref={ref}
      dir="ltr"
      type="text"
      inputMode="decimal"
      onChange={handleChange}
      value={internalValue.replace('.', decimal || localeDecimal)}
    />
  )
}

const MoneyFieldWithForwardedRef = forwardRef(MoneyField)
Object.defineProperty(MoneyFieldWithForwardedRef, 'dir', { value: 'ltr' })

export default MoneyFieldWithForwardedRef
